<template>
  <div class="title">
      <p class="chinese">{{titleName.chinese}}</p>
      <p class="xian"><img src="../image/xian.png" alt=""></p>
       <p class="english">{{titleName.english}}</p>
  </div>
</template>
<script>
  export default {
    name:'',
    components: {},
    props:{
      titleName:{

      }
    },
    data () {
      return {

      };
    },
    watch: {},
    created() {},
    beforeMount() {},
    mounted() {},
    methods: {},
    computed: {}
  }
</script>
<style lang='scss' scoped>
.title{
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
}
.xian{
  color: #803444;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  margin-top: 10px;
  img{
    width: 80px;
  }
}
.chinese {
  font-size: 36px;
  font-weight: 400;
  color: #1D70B8;
  letter-spacing: 2px;
  text-align: center;
}
.english {
  font-size: 26px;
  font-weight: 400;
  color: #cccccc;
  text-align: center;
  margin-top: 10px;
}
</style>
